(ns motorsaif.web.components.tabular
  (:require
   [reagent.core :as r]))

(defn accordion [vis hidden]
  (let [*shown (r/atom false)]
    (fn []
      [:div.accordion
       [:div.vis
        {:on-click #(swap! *shown not)}
        vis]
       (when @*shown
         [:div.hidden
          hidden])])))

(defn table [data]
  [:div.admin-data
   (map (fn [{:keys [hidden visible]}]
          [:div.entry
           [accordion
            (into [:div.visible]
                  (map (fn [{:keys [type title val]}]
                         (if (= type :img)
                           [:div.thumb
                            [:img {:src val
                                   }]]
                           [:div
                            [:span.title title]
                            [:span.val val]])) visible))
            (into [:div.folded]
                  (map (fn [c]
                         [c])
                       hidden))]]) data)])
